import request from '@/utils/request'

export function getCode(data) {
  return request({
    url: 'api/we_chat/getAppCode',
    method: 'post',
    data
  })
}